<template>
    <b-navbar
        type="light"
        class="navbar-light theme-nav fixed-top"
        toggleable="lg"
        fixed="top"
        v-b-scrollspy:nav-scroller
    >
        <div class="container">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand" :to="{name:'home'}">
                <AnimatedLogo/>
            </b-navbar-brand>
            <b-collapse class="default-nav" is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
                    <b-nav-item :to="{name:'Home_one'}">Home</b-nav-item>
                    <b-nav-item :to="{name:'Home_one'}">Our Games</b-nav-item>
                    <b-nav-item :to="{name:'Home_one'}">Hire Us</b-nav-item>
                    <b-nav-item :to="{name:'Home_one'}">Skills</b-nav-item>

                    <b-nav-item-dropdown right-alignment text="walkthroughs" class="nav-link">
                        <b-dropdown-item class="nav-link" :to="{name:'office'}">The Office</b-dropdown-item>
                        <b-dropdown-item class="nav-link" :to="{name:'car'}">The Car</b-dropdown-item>
                        <b-dropdown-item class="nav-link" :to="{name:'jailcell'}">The Jail Cell</b-dropdown-item>
                        <b-dropdown-item class="nav-link" :to="{name:'garage'}">The Garage</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown right-alignment text="leaderboards" class="nav-link">
                        <!--    <b-dropdown-item class="nav-link"  :to="{name:'blog_list'}" >Escape the Room</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_details'}"> Escape the Airplane</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  :to="{name:'Blog_leftside'}"> Christmas Escape</b-dropdown-item>-->
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/puzzleoftheday/"
                        >Puzzle of the Day</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/gameofwords/"
                        >Game of Words</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/wordplay/leaderboard.html"
                        >Word Play</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/wordwiz/"
                        >Word Wiz</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/angelinvestor/"
                        >Angel Investor</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <!--   <b-nav-item href="#contact">contact us</b-nav-item> -->
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>
<script>
export default {
    name: "Navbar",
    beforeCreate: function() {
        document.body.className = "";
    }
};
</script>



// WEBPACK FOOTER //
// src/components/navbar_nested.vue